<template>
  <div class="container">
    <template v-if="!selectedClient || guideline === null">
      <div class="loader">
        <base-loader/>
      </div>
    </template>
    <template v-else>
      <div v-resize @resize="resizeHandler" ref="editor" class="editor-wrapper">
        <editor
          :key="selectedClient._id"
          v-model="guideline"
          :disabled="isCurrentUserClientCollaborator"
          :init="{
            plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
            toolbar: 'undo redo | formatselect | bold italic backcolor | link | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
            menubar: false,
            statusbar: false,
            height: editorHeight()
          }"
        ></editor>
      </div>
     <div v-if="guidelineCopy !== guideline" class="editor-footer">
        <button @click.stop="onCancel" class="cancel-button">Cancel</button>
        <button @click.stop="onSave" class="update-button">Update</button>
     </div>
    </template>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { mapActions } from 'vuex'
import ToasterService from '@/services/toasterService'

/**
 * Component for editing client guideline
 */
export default {
  name: 'CompanyGuidelines',
  components: {
    editor: Editor
  },
  data () {
    return {
      guideline: null,
      guidelineCopy: null
    }
  },
  created () {
    this.guideline = this.selectedClient && (this.selectedClient.guideline || '')
    this.guidelineCopy = this.guideline
  },
  methods: {
    ...mapActions([
      'updateCompanyGuideline'
    ]),
    resizeHandler (event) {
      const blockHeight = event.detail.height
      this.$refs.editor.children[1].setAttribute('style', `height:${blockHeight}px; visibility: hidden;`)
    },
    onSave: async function () {
      if (this.guideline === this.guidelineCopy) {
        return
      }
      await this.updateCompanyGuideline({ clientId: this.clientId, newGuideline: this.guideline }).catch(error => {
        ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'Error has occurred during update!')
        console.error(error)
      })
    },
    onCancel: function () {
      this.guideline = this.guidelineCopy
    },
    editorHeight () {
      return document.documentElement.clientHeight * 0.67
    }
  },
  watch: {
    /* guideline is attached to client data so we don't need to get additional request to fetch client guideline by changing client */
    'selectedClient.guideline': function () {
      this.guideline = this.selectedClient && (this.selectedClient.guideline || '')
      this.guidelineCopy = this.guideline
    }
  }
}
</script>

<style lang="scss">
  /*this classes override library classes thus "scoped" attribute was removed from style tag*/
  .tox-notifications-container {
    display: none;
  }

  .editor-wrapper {
    .tox-toolbar {
      background: rgba(1, 22, 39, 0.1) !important;
      border-top-right-radius: 4px !important;
      border-top-left-radius: 4px !important;
      padding: 10px 15px !important;
    }

    .tox.tox-tinymce {
      width: auto !important;
      height: auto;
      border: none !important;
      border-radius: $rfx-default-border-radius !important;
    }

    .tox-edit-area {
      border-top: none !important;
      border-left: 1px solid rgba(1, 22, 39, 0.1) !important;
      border-right: 1px solid rgba(1, 22, 39, 0.1) !important;
      border-bottom: 1px solid rgba(1, 22, 39, 0.1) !important;
      border-bottom-right-radius: 4px !important;
      border-bottom-left-radius: 4px !important;
    }

    .tox-icon > svg {
      fill: #8b959c !important;
    }

    .tox-tbtn.tox-tbtn--enabled {
      background: none !important;

      svg {
        fill: $rfx-bright-turquoise !important;
      }
    }
  }

  .editor-wrapper {
    margin-bottom: 30px;
    min-height: 470px;
    height: 67vh;
  }

  .editor-footer {
    display: flex;
    justify-content: flex-end;
    position: relative;
    z-index: 3;
  }

  .update-button {
    text-transform: uppercase;
    color: white;
    width: 160px;
    font-size: 13px;
    font-weight: 500;
    height: 50px;
    border-radius: 4px;
    background-color: $rfx-medium-march;
    border: none;
  }

  .cancel-button {
    @extend .update-button;
    color: $rfx-dark-march;
    border-radius: 4px;
    background-color: white;
    position: inherit;
    border: none;
    margin-right: 30px;
  }

   button:focus {
      outline: 0;
   }

   button:hover {
     cursor: pointer;
   }

    .loader {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: calc(100vh - 530px);
    }
</style>
